<template>
  <select
    class="border-none rounded focus-interaction w-full appearance-none"
    v-bind="$attrs"
    :value="modelValue"
    @input="onInput"
    v-if="!loading"
  >
    <option
      v-for="option in options"
      :value="option.Id"
      :key="`option-${option.Id || 'empty'}`"
      class="text-neutral-1000"
    >
      {{ option.Label }}
    </option>
  </select>
</template>

<script lang="ts" setup>
import { SelectOption } from '@planbord/shared/models';

const emit = defineEmits<{ (e: 'update:modelValue', value: unknown): void }>();
withDefaults(
  defineProps<{
    label?: string;
    loading?: boolean;
    translate?: boolean;
    translatePrefix?: string;
    error?: string;
    modelValue: unknown;
    options: SelectOption[];
  }>(),
  {
    loading: false,
    translate: false,
    translatePrefix: '',
  }
);

function onInput(e: Event) {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.value !== '' ? target.value : null);
}
</script>
